export const FETCH_IMPORT_DETAILS = 'FETCH_IMPORT_DETAILS';
export const FETCH_IMPORT_DETAILS_SUCCESS = 'FETCH_IMPORT_DETAILS_SUCCESS';
export const FETCH_IMPORT_DETAILS_FAILED = 'FETCH_IMPORT_DETAILS_FAILED';
export const SET_SEARCH_IMPORT = 'SET_SEARCH_IMPORT';
export const SET_SORT_CRITERIA = 'SET_SORT_CRITERIA';

export const VALIDATE_FILE = 'VALIDATE_FILE';
export const VALIDATE_FILE_SUCCESS = 'VALIDATE_FILE_SUCCESS';
export const VALIDATE_FILE_FAILED = 'VALIDATE_FILE_FAILED';

export const DOWNLOAD_VALIDATE_FILE = 'DOWNLOAD_VALIDATE_FILE';
export const DOWNLOAD_VALIDATE_FILE_SUCCESS = 'DOWNLOAD_VALIDATE_FILE_SUCCESS';
export const DOWNLOAD_VALIDATE_FILE_FAILED = 'DOWNLOAD_VALIDATE_FILE_FAILED';

export const PROCESS_IMPORT = 'PROCESS_IMPORT';
export const PROCESS_IMPORT_SUCCESS = 'PROCESS_IMPORT_SUCCESS';
export const PROCESS_IMPORT_FAILED = 'PROCESS_IMPORT_FAILED';
export const UPDATE_PROCESS_IMPORT_RESPONSE = 'UPDATE_PROCESS_IMPORT_RESPONSE';

export const DOWNLOAD_SNAPSHOT_FILE = 'DOWNLOAD_SNAPSHOT_FILE';
export const DOWNLOAD_SNAPSHOT_FILE_SUCCESS = 'DOWNLOAD_SNAPSHOT_FILE_SUCCESS';
export const DOWNLOAD_SNAPSHOT_FILE_FAILED = 'DOWNLOAD_SNAPSHOT_FILE_FAILED';

export const DOWNLOAD_FILE = 'DOWNLOAD_FILE';
export const DOWNLOAD_FILE_SUCCESS = 'DOWNLOAD_FILE_SUCCESS';
export const DOWNLOAD_FILE_FAILED = 'DOWNLOAD_FILE_FAILED';

export const DELETE_FILE = 'DELETE_FILE';
export const DELETE_FILE_SUCCESS = 'DELETE_FILE_SUCCESS';
export const DELETE_FILE_FAILED = 'DELETE_FILE_FAILED';

export const fetchImportDetails = (payload) => ({
  type: FETCH_IMPORT_DETAILS,
  payload,
});

export const fetchImportDetailsSuccess = (payload) => ({
  type: FETCH_IMPORT_DETAILS_SUCCESS,
  payload,
});

export const fetchImportDetailsFailed = (payload) => ({
  type: FETCH_IMPORT_DETAILS_FAILED,
  payload,
});

export const setSearchImport = (payload) => ({
  type: SET_SEARCH_IMPORT,
  payload,
});
export const setSortCriteria = (payload) => ({
  type: SET_SORT_CRITERIA,
  payload,
});

//--------------------validate file----------------
export const validateFile = (payload) => ({
  type: VALIDATE_FILE,
  payload,
});

export const validateFileSuccess = (dataValidated) => ({
  type: VALIDATE_FILE_SUCCESS,
  dataValidated,
});

export const validateFileFailed = () => ({
  type: VALIDATE_FILE_FAILED,
});

export const downloadValidateFile = (payload) => ({
  type: DOWNLOAD_VALIDATE_FILE,
  payload,
});

export const downloadValidateFileSuccess = () => ({
  type: DOWNLOAD_VALIDATE_FILE_SUCCESS,
});

export const downloadValidateFileFailed = () => ({
  type: DOWNLOAD_VALIDATE_FILE_FAILED,
});

//--------------------process cleanup----------------
export const processImport = (payload) => ({
  type: PROCESS_IMPORT,
  payload,
});

export const processImportSuccess = (dataProcessed) => ({
  type: PROCESS_IMPORT_SUCCESS,
  dataProcessed,
});

export const processImportFailed = () => ({
  type: PROCESS_IMPORT_FAILED,
});

export const updateProcessImportResponse = (payload) => ({
  type: UPDATE_PROCESS_IMPORT_RESPONSE,
  payload,
});

//-----------------------download snapshot file-------------------
export const downloadSnapshotFile = (payload) => ({
  type: DOWNLOAD_SNAPSHOT_FILE,
  payload,
});

export const downloadSnapshotFileSuccess = () => ({
  type: DOWNLOAD_SNAPSHOT_FILE_SUCCESS,
});

export const downloadSnapshotFileFailed = () => ({
  type: DOWNLOAD_SNAPSHOT_FILE_FAILED,
});

//-----------------------download snapshot file-------------------

//-----------------------download file-------------------
export const downloadFile = (payload) => ({
  type: DOWNLOAD_FILE,
  payload,
});

export const downloadFileSuccess = () => ({
  type: DOWNLOAD_FILE_SUCCESS,
});

export const downloadFileFailed = () => ({
  type: DOWNLOAD_FILE_FAILED,
});

//-----------------------download file-------------------
export const deleteFile = (payload) => ({
  type: DELETE_FILE,
  payload,
});

export const deleteFileSuccess = () => ({
  type: DELETE_FILE_SUCCESS,
});

export const deleteFileFailed = () => ({
  type: DELETE_FILE_FAILED,
});
